import axios from "axios";
// const API_BASE_URL = 'http://localhost:56913/api';
const API_BASE_URL = 'https://webapi.iee.ir/api';
// const API_BASE_URL = 'https://stageapi.iee.ir/api';

export const showHidden = false; // show for demo
export var intervalSecond = 1500;
export const beEnglish = false;
export function hasFilter(obj) {
    for (var key in obj) {
        if (obj[key] !== null && obj[key] !== "")
            return true;
    }
    return false;
}
export function addUrlParamters(url, searchFilters) {
    Object.keys(searchFilters).forEach(key => {
        if (searchFilters[key] !== null && searchFilters[key] != undefined) {
            if (searchFilters[key].hasOwnProperty('id')) {
                url.searchParams.set(key, searchFilters[key].id);
            }
            else {
                url.searchParams.set(key, searchFilters[key]);
            }
        }
    });
    return url;
}
export function cleanContent (content) {
    // Replace <br /> tags with an empty string to remove them
    return content.replace(/<br\s*\/?>/g, '').replace(/font-family\s*:\s*[^;]*;/gi, '');
};
export const getEvent = async (date) => {
    try {
        const url = `${API_BASE_URL}/TimeLine/GetTimeLines`;
        const chosenDate = { Date: date };

        const response = await axios.post(url, null, {
            headers: { "Content-Type": "application/json" },
            params: chosenDate,
        });

        // ✅ return inside try, where response exists
        return response.data.results;
    } catch (error) {
        console.error("Failed to fetch event data", error);
        return []; // return a safe fallback
    }
};

export default API_BASE_URL;